import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { GlobalErrorHandler } from './services/global-error.handler';

import { environment } from './../environments/environment';
//import { PathLocationStrategy, LocationStrategy } from '@angular/common'; //new line
//import { HashLocationStrategy, LocationStrategy } from '@angular/common'; //new line

//import { ChartsModule } from 'ng2-charts';

//Material
import { MaterialModule } from './material-module';
//import { NgMaterialMultilevelMenuModule } from 'ng-material-multilevel-menu';

//PRIMENG
import { CalendarModule } from 'primeng/calendar';

//MAP
import { AgmCoreModule, GoogleMapsAPIWrapper } from '@agm/core';
import { AgmSnazzyInfoWindowModule } from '@agm/snazzy-info-window';
import { AgmJsMarkerClustererModule, ClusterManager } from '@agm/js-marker-clusterer';

import { InlineSVGModule } from 'ng-inline-svg';
import { ProgressBarModule } from "angular-progress-bar";

//Google Analytics
import { Angulartics2Module } from 'angulartics2';

//Modules
import { LoginComponent, LoginDialogOlvidePass, LoginDialogErrorPass, LoginDialogValidate } from './modules/login/login.component';
import { FormsModule, FormBuilder, ReactiveFormsModule } from '@angular/forms';

//Sidebar
import { BasicAuthInterceptor } from './services/auth/basic-auth.interceptor';
import { AuthenticationService } from './services/auth/authentication.service';
import { ErrorInterceptor } from './services/error.interceptor';

import { MapaPopUpComponent } from './shared/mapa/mapa-popup/mapa-popup.component';
import { MapaToolsComponent } from './shared/mapa/mapa-tools/mapa-tools';
import { MapaFullComponent } from './shared/mapa/mapa-full/mapa-full.component';
import { mapIcon } from './shared/mapa/mapa-tools/mapa-icons';
import { AgmDirectionModule } from 'agm-direction';

import { AdminMenuComponent } from './shared/admin/admin-menu/admin-menu.component';
import { HeaderTopComponent } from './shared/header/header-top/header-top.component';
import { ToolsHeaderComponent } from './shared/mapa/mapa-tools-pop/tools-header/tools-header.component';
import { ToolsConfigComponent } from './shared/mapa/mapa-tools-pop/tools-config/tools-config.component';
import { ToolsIraMovilComponent } from './shared/mapa/mapa-tools-pop/tools-iramovil/tools-iramovil.component';
import { ToolsCapasComponent } from './shared/mapa/mapa-tools-pop/tools-capas/tools-capas.component';
import { ToolsRutasComponent } from './shared/mapa/mapa-tools-pop/tools-rutas/tools-rutas.component';
import { ToolsPuntosClienteComponent } from "./shared/mapa/mapa-tools-pop/tools-puntoscliente/tools-puntoscliente.component";
import { ToolsBuscadorComponent } from './shared/mapa/mapa-tools-pop/tools-buscador/tools-buscador.component';
import { AgregarPuntoComponent } from './shared/mapa/mapa-tools/agregar-punto/agregar-punto.component';
import { AgregarGeocercaComponent } from './shared/mapa/mapa-tools/agregar-geocerca/agregar-geocerca.component';
import { RecorridoResumenSmallComponent } from './shared/mapa/recorrido-resumen-small/recorrido-resumen-small.component';
import { MapaInfowindowComponent } from './shared/mapa/mapa-tools/mapa-infowindow/mapa-infowindow.component';
import { MapaInfowindowPuntoClienteComponent } from './shared/mapa/mapa-tools/mapa-infowindow-puntocliente/mapa-infowindow-puntocliente.component';

//import { GestureConfig } from '@angular/material/core/gestures/gesture-config';
import { FilterDistanciaEntreMovilesComponent } from './modules/flota/filter-distancia-entre-moviles/filter-distancia-entre-moviles.component';
import { FilterInformeRoadShowComponent } from './modules/flota/filter-informe-roadshow/filter-informe-roadshow.component';
import { InformeRoadShowComponent } from './modules/flota/informe-roadshow/informe-roadshow.component';
import { InformeHojaRutaComponent } from './modules/flota/informe-hoja-ruta/informe-hoja-ruta.component';
import { MovilHojaRutaComponent } from './modules/flota/informe-hoja-ruta/movil-hoja-ruta.component';
import { PanelHojaRutaComponent } from './modules/flota/panel-hoja-ruta/panel-hoja-ruta.component';

//import { FilterInformeNovedadesComponent } from './modules/flota/filter-informe-novedades/filter-informe-novedades.component';
//import { InformeNovedadesComponent } from './modules/flota/informe-novedades/informe-novedades.component';

import { UserPerfilComponent } from './modules/user/user-perfil/user-perfil.component';
import { InicioComponent } from './inicio/inicio.component';
import { InformesComponent } from './modules/informes/informes.component';
import { DistanciaEntreMovilesComponent } from './modules/flota/distancia-entre-moviles/distancia-entre-moviles.component';
import { MembresiaDialogComponent } from './inicio/membresia-dialog/membresia-dialog.component';
import { ContactoDialogComponent } from './inicio/membresia-dialog/contacto-dialog.component';

import { FusionChartsModule } from 'angular-fusioncharts';
import { ServiceWorkerModule } from '@angular/service-worker';
import { PrivacyPolicyComponent } from './modules/privacy-policy/privacy-policy.component';
import { SharedModule } from './shared/shared.module';
import { AdminModule } from './modules/admin/admin.module';

//PIPES
@NgModule({
  declarations: [
    AppComponent,
    InicioComponent,
    //Login - Dialogo Alertas en Login
    LoginComponent, LoginDialogOlvidePass, LoginDialogErrorPass, LoginDialogValidate,
    MapaPopUpComponent,
    MapaFullComponent, MapaInfowindowComponent, MapaInfowindowPuntoClienteComponent,
    DistanciaEntreMovilesComponent,
    ToolsHeaderComponent,
    ToolsIraMovilComponent,
    ToolsConfigComponent,
    ToolsCapasComponent,
    ToolsRutasComponent,
    ToolsPuntosClienteComponent,
    ToolsBuscadorComponent,

    AgregarPuntoComponent,
    AgregarGeocercaComponent,
    FilterDistanciaEntreMovilesComponent,
    FilterInformeRoadShowComponent,
    InformeRoadShowComponent,
    InformeHojaRutaComponent,
    MovilHojaRutaComponent,
    PanelHojaRutaComponent,
    // FilterInformeNovedadesComponent,
    // InformeNovedadesComponent,
    ToolsHeaderComponent, ToolsIraMovilComponent, ToolsConfigComponent, ToolsCapasComponent, ToolsRutasComponent, ToolsBuscadorComponent,
    UserPerfilComponent, HeaderTopComponent, RecorridoResumenSmallComponent,
    AdminMenuComponent,
    //INFORMES
    InformesComponent,
    PrivacyPolicyComponent,
    MembresiaDialogComponent,
    ContactoDialogComponent,
    // ControlVelocidadComponent,
    // MovilvelocidadComponent,
    // LineChartComponent
  ],
  entryComponents: [
    //Dialogo Alertas en Login
    LoginDialogOlvidePass,
    LoginDialogErrorPass,
    LoginDialogValidate,
    MapaPopUpComponent,
    AgregarPuntoComponent,
    MembresiaDialogComponent,
    ContactoDialogComponent
  ],
  imports: [
    BrowserModule,
    AgmCoreModule.forRoot(environment.agmSettings),
    AgmJsMarkerClustererModule,
    AgmSnazzyInfoWindowModule,
    AgmDirectionModule,

    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    //NgMaterialMultilevelMenuModule,
    CalendarModule,
    InlineSVGModule.forRoot(),
    //ChartsModule,
    ProgressBarModule,
    //Google Analytics
    Angulartics2Module.forRoot(),
    //Angulartics2UirouterModule.forRoot(),
    FusionChartsModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    SharedModule,
    AdminModule
  ],
  providers: [
    FormBuilder,
    AuthenticationService,
    { provide: HTTP_INTERCEPTORS, useClass: BasicAuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    //{ provide: LocationStrategy, useClass: HashLocationStrategy }, //new line
    //{ provide: LocationStrategy, useClass: PathLocationStrategy},
    GoogleMapsAPIWrapper,
    ClusterManager,
    mapIcon,
    MapaToolsComponent,
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule { }
